import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaStar, FaQuoteLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './Testimonials.css';
import user from "../assest/user.jpg";

const Testimonials = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const testimonials = [
    {
      id: 1,
      name: "Shaurya Mittal",
      position: "Manager",
      // company: "TechStart Inc.",
      image: user,
      rating: 5,
      text: "TechFlow transformed our entire digital presence. Their team delivered a stunning website and mobile app that exceeded our expectations. The attention to detail and communication throughout the project was exceptional."
    },
    {
      id: 2,
      name: "Dhruv",
      position: "Founder",
      // company: "InnovateLab",
      image: user,
      rating: 5,
      text: "Working with TechFlow was a game-changer for our business. They built a scalable e-commerce platform that handles thousands of transactions daily. Their technical expertise and project management skills are outstanding."
    },
    {
      id: 3,
      name: "Rudra",
      position: "Marketing Director",
      //company: "GrowthCo",
      image: user,
      rating: 5,
      text: "The UI/UX design work from TechFlow was phenomenal. They understood our brand perfectly and created an intuitive interface that our users love. Our conversion rates increased by 40% after the redesign."
    },
    {
      id: 4,
      name: "Aarav",
      position: "CTO",
      //company: "DataFlow Systems",
      image: user,
      rating: 5,
      text: "TechFlow's backend development services are top-notch. They built a robust API infrastructure that scales beautifully with our growing user base. Their code quality and documentation are exemplary."
    },
    {
      id: 5,
      name: "Nikhil Yadav",
      position: "Product Manager",
      //company: "CloudTech",
      image: user,
      rating: 5,
      text: "The mobile app development team at TechFlow is incredible. They delivered a feature-rich iOS and Android app ahead of schedule. The user experience is smooth and the performance is excellent."
    }
  ];

  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, testimonials.length]);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    setIsAutoPlaying(false);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    setIsAutoPlaying(false);
  };

  const goToTestimonial = (index) => {
    setCurrentTestimonial(index);
    setIsAutoPlaying(false);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <FaStar
        key={index}
        className={index < rating ? 'star filled' : 'star'}
      />
    ));
  };

  return (
    <section className="testimonials">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <span className="section-badge">Client Testimonials</span>
          <h2 className="section-title">
            What Our <span className="gradient-text">Clients Say</span>
          </h2>
          <p className="section-description">
            Don't just take our word for it. Here's what our satisfied clients have to say 
            about working with TechFlow Solutions.
          </p>
        </motion.div>

        <div className="testimonials-container">
          <motion.div
            className="testimonial-navigation"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <button
              className="nav-button prev"
              onClick={prevTestimonial}
              aria-label="Previous testimonial"
            >
              <FaChevronLeft />
            </button>
            <button
              className="nav-button next"
              onClick={nextTestimonial}
              aria-label="Next testimonial"
            >
              <FaChevronRight />
            </button>
          </motion.div>

          <div className="testimonial-slider">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentTestimonial}
                className="testimonial-card"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.5 }}
              >
                <div className="quote-icon">
                  <FaQuoteLeft />
                </div>

                <div className="testimonial-content">
                  <div className="rating">
                    {renderStars(testimonials[currentTestimonial].rating)}
                  </div>

                  <blockquote className="testimonial-text">
                    "{testimonials[currentTestimonial].text}"
                  </blockquote>

                  <div className="testimonial-author">
                    <div className="author-image">
                      <img
                        src={testimonials[currentTestimonial].image}
                        alt={testimonials[currentTestimonial].name}
                      />
                    </div>
                    <div className="author-info">
                      <h4 className="author-name">
                        {testimonials[currentTestimonial].name}
                      </h4>
                      <p className="author-position">
                        {testimonials[currentTestimonial].position}
                      </p>
                      <p className="author-company">
                        {testimonials[currentTestimonial].company}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <motion.div
            className="testimonial-dots"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentTestimonial ? 'active' : ''}`}
                onClick={() => goToTestimonial(index)}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </motion.div>
        </div>

        <motion.div
          className="testimonials-stats"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="stats-grid">
            <div className="stat-item">
              <h3>100%</h3>
              <p>Client Satisfaction</p>
            </div>
            <div className="stat-item">
              <h3>78+</h3>
              <p>Projects Completed</p>
            </div>
            <div className="stat-item">
              <h3>105+</h3>
              <p>Happy Clients</p>
            </div>
            <div className="stat-item">
              <h3>12+</h3>
              <p>Years Experience</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;

